





















































import BaseIcon from "vuecomponents/base_icon"
import PadletCollection from "vuecomponents/padlet_collection"
import t from "vuedirectives/t"
import { __ } from "bits/intl"
import device from "bits/device"
import { fetchJson } from "@padlet/fetch"
import { trackEvent } from "bits/analytics"
import debounce from "bits/debounce"

debouncedWallSearch = debounce (query, prelude, thenHandler) ->
  prelude()
  fetchJson('/search/padlets.json', { query: { q: query } }).then(thenHandler)
, 500

export default
  props:
    status:
      default: "collapsed"
  data: ->
    {
      working: false
      previousQuery: ""
      searchResults: []
      recents: []
      expansionStatus: this.status
      query: "",
      emptyResultsMessage: __('Nothing matches your search query.')
    }
  computed:
    walls: ->
      if this.query == "" then this.recents else this.searchResults
    isEmpty: ->
      this.query and not this.working
  methods:
    makeSearchCall: ->
      self = this
      debouncedWallSearch.cancel()
      prelude = -> self.working = true
      debouncedWallSearch self.query, prelude, (data) ->
        self.working = false
        self.searchResults = data.hits

      #fetchJson("/search/padlets.json",
      #  data:
      #    q: self.query
      #).then((data) ->
      #  self.working = false
      #  self.searchResults = data.hits
      #)
    makeRecentsCall: ->
      self = this
      self.working = true
      fetchJson("/walls",
        data:
          filter: "recents"
      ).then((data) ->
        self.working = false
        self.recents = data
      )

    collapse: (e) ->
      this.expansionStatus = "collapsed"
      this.$refs.searchField.blur()
      this.query = ""
      this.previousQuery = ""
      this.searchResults = []
    expand: (e) ->
      unless this.expansionStatus == "expanded"
        trackEvent("Universal Search", "Open")
        this.makeRecentsCall()
        this.expansionStatus = "expanded"
        this.$refs.searchField.focus()
    resetSearch: (e) ->
      this.$refs.searchField.value = ""
      this.$refs.searchField.focus()
      this.search()
    search: (e) ->
      this.query = this.$refs.searchField.value
      if this.query is ""
        this.makeRecentsCall()
      else
        if this.previousQuery isnt this.query
          this.previousQuery = this.query
          this.makeSearchCall()
  components:
    PadletCollection: PadletCollection
    BaseIcon: BaseIcon
  directives:
    t: t
